export { TransportErrors } from './enums/errors';
export { Event as TransportEvent } from './enums/event';
export { Method } from './enums/method';
export { PluginEvent } from './enums/plugin_event';
export { DisconnectionReason } from './enums/disconnection_reason';
export { ConnectionObserver, } from './_internal/connection_observer';
export { createAbortControllerLike, createAbortSignalWithTimeout, } from './helpers/abortcontroller';
import { dealerCreator } from './plugins/dealer';
import * as Fetch from './http/fetch';
import { Transport, } from './transport';
import * as XHR from './http/xhr';
import { HTTPResponse } from './http/response';
import { HTTPRequest } from './http/request';
import { PublicTransport } from './_internal/public_transport';
// XResolveProvider
export { createProvider as createXResolveProvider } from './providers/endpoints/xresolve';
// spotify.com providers
export { createEndpointsProvider as createSpotifyComEndpointsProvider, createTokenProvider as createSpotifyComTokenProvider, createProviders as createSpotifyComProviders, } from './providers/spotify_com';
// Plugins
export { DEALER_PLUGIN_NAME, DealerErrors, } from './plugins/dealer';
export { dealerCreator };
export { REQUEST_TRANSFORMER_PLUGIN_NAME, requestTransformerCreator, } from './plugins/request_transformer';
/**
 * Creates an instance of Transport.
 *
 * @param config - The configuration object for this transport instance.
 * @returns The created Transport instance.
 */
export function createBaseTransport(config) {
    const _config = Object.assign({}, config);
    if (!_config.XHR) {
        _config.XHR = XHR;
    }
    _config.Fetch = Fetch;
    return Transport.create(_config);
}
/**
 * Creates an instance of Transport with default plugins added.
 *
 * @param config - The configuration object for this transport instance.
 * @returns The created Transport instance.
 */
export function createTransport(config) {
    const transport = createBaseTransport(config);
    transport.addPlugin(dealerCreator, { WebSocket: WebSocket });
    return transport;
}
//# sourceMappingURL=index.js.map